// extracted by mini-css-extract-plugin
module.exports = {"container":"Dropdown-styles_container__2VxeW","menu":"Dropdown-styles_menu__35R7C","left":"Dropdown-styles_left__3b47d","right":"Dropdown-styles_right__1ZbBu"};